import { gql } from '@apollo/client';

export const DRIVERS = gql`
  query Drivers($data: DriversRequestParams!) {
    drivers(data: $data) {
      results {
        id
        name
        active
      }
      pagination {
        currentPage
        pageSize
        totalPages
        totalResults
      }
    }
  }
`;

export const DRIVER = gql`
  query Driver($driverId: Int!) {
    driver(driverId: $driverId) {
      id
      userId
      name
      fleetId
      licensePlate
      active
      photoFile {
        externalKey
        contentType
      }
      taxiLicenseFile {
        externalKey
        contentType
      }
      identificationFile {
        externalKey
        contentType
      }
      mobilePhoneNumber
      mobilePhoneType
      licenseExpiry
    }
  }
`;

export const CREATE_DRIVER = gql`
  mutation CreateDriver($data: DriverCreateParams!) {
    createDriver(data: $data) {
      id      
    }
  }
`;

export const UPDATE_DRIVER = gql`
  mutation UpdateDriver($data: DriverUpdateParams!) {
    updateDriver(data: $data) {
      id
    }
  }
`;

export const REMOVE_DRIVER = gql`
  mutation RemoveDriver($driverId: Int!) {
    removeDriver(driverId: $driverId)
  }
`;

export const UPLOAD_DRIVER_PHOTO = gql`
  mutation UploadDriverPhoto($id: Int!, $file: Upload!) {
    uploadDriverPhoto(id: $id, file: $file)
  }
`;

export const UPLOAD_DRIVER_TAXI_LICENSE = gql`
  mutation UploadDriverTaxiLicense($id: Int!, $file: Upload!) {
    uploadDriverTaxiLicense(id: $id, file: $file)
  }
`;

export const UPLOAD_DRIVER_IDENTIFICATION = gql`
  mutation UploadDriverIdentificationFile($id: Int!, $file: Upload!) {
    uploadDriverIdentificationFile(id: $id, file: $file)
  }
`;
